<template>
  <a-back-top
    v-if="!isHidden"
    v-bind="attrs"
    :class="bem.b()"
    :visibility-height="show === true ? 0 : visibilityHeight"
    :shape="shape"
    :description="shape === 'circle' ? '' : description"
    :target="getTarget"
  >
    <template
      v-for="item in Object.keys($slots).filter((key) => key !== 'icon')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="icon.iconName || $slots.icon" #icon>
      <slot name="icon">
        <ll-icon v-bind="icon" />
      </slot>
    </template>
  </a-back-top>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, getCurrentInstance, useAttrs } from 'vue'
import { backTopProps } from './back-top'

defineOptions({ name: 'LlBackTop' })

const props = defineProps(backTopProps)

const bem = createNamespace('back-top')
const attrs = useAttrs()
const instance = getCurrentInstance()

const isHidden = computed(() => props.show === false)

// 计算目标容器
const getTarget = computed(() => {
  if (props.target && typeof props.target === 'function') return props.target

  // 否则查找最近的可滚动祖先容器
  return () => {
    if (!instance?.proxy?.$el) return window

    let current: HTMLElement | null = instance.proxy.$el.parentElement

    while (current && current !== document.documentElement) {
      const style = window.getComputedStyle(current)
      const overflowY = style.overflowY
      const overflow = style.overflow

      const isScrollable =
        (overflowY === 'scroll' ||
          overflowY === 'auto' ||
          overflow === 'scroll' ||
          overflow === 'auto') &&
        current.scrollHeight > current.clientHeight

      if (isScrollable) return current

      current = current.parentElement
    }

    return window
  }
})
</script>
